/**
 * Do not edit directly, this file was auto-generated.
 */

export const RadiusS = '4px'; // Small accents, tiny badges
export const RadiusM = '8px'; // STANDARD — buttons, inputs, modals, cards
export const RadiusL = '12px'; // Larger surfaces (optional)
export const RadiusPill = '9999px'; // Pill chips, tags, pill-shaped buttons
